import { useRef, useState } from "react";
import locationIcon from "../../assets/locationn.png";
import fulltimeIcon from "../../assets/fulltime-icon.png";
import experienceIcon from "../../assets/experience-icon.png";
import uploadIcon from "./assets/upload-icon.svg";

const JobDetails = () => {
  const applyFormRef = useRef(null);

  const [formData, setFormData] = useState({
    name: "",
    mobile_number: "",
    email: "",
    cover_letter: "",
    resume: null,
  });

  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState("");

  const handleChange = (e) => {
    const { name, value, files } = e.target;

    if (name === "resume") {
      setFormData((prev) => ({ ...prev, resume: files[0] }));
    } else {
      setFormData((prev) => ({ ...prev, [name]: value }));
    }
  };

  const fileToBase64 = (file) =>
    new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => resolve(reader.result);
      reader.onerror = reject;
    });

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setMessage("");

    try {
      let base64Resume = "";
      if (formData.resume) {
        base64Resume = await fileToBase64(formData.resume);
      }

      const payload = {
        ...formData,
        resume: base64Resume,
      };

      const response = await fetch(
        "https://api.app.mawalog.com/v1.2/job_apply",
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(payload),
        }
      );

      const result = await response.json();

      if (result.success) {
        setMessage("Application submitted successfully!");
        setFormData({
          name: "",
          mobile_number: "",
          email: "",
          cover_letter: "",
          resume: null,
        });
        document.getElementById("resume").value = "";
      } else {
        setMessage("Submission failed.");
      }
    } catch {
      setMessage("Network error or server issue.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <div className="bg-white text-gray-800">
        <div className="bg-[#F9FCD0] py-14 text-center px-4">
          <div className="text-gray-700 text-sm font-medium mb-3">
            Lentera Technologies <span className="mx-2">|</span> Full Time
          </div>

          <h1 className="text-3xl md:text-5xl font-semibold text-gray-900 mb-6">
            Power Apps Developer
          </h1>

          <button
            onClick={() =>
              applyFormRef.current.scrollIntoView({ behavior: "smooth" })
            }
            className="bg-[#F4B731] hover:bg-[#e5a925] text-black font-semibold px-6 py-3 rounded-md text-sm md:text-base transition-all duration-200"
          >
            I’M INTERESTED <span className="ml-1">→</span>
          </button>
        </div>

        <div className="bg-white px-6 md:px-16 py-12">
          <div className="grid grid-cols-1 lg:grid-cols-3 gap-12 items-start">

            <div className="lg:col-span-2 space-y-12">

              <div>
                <h2 className="text-[32px] font-semibold text-[#212129] mb-6">
                  Job Summary
                </h2>

                <p className="text-[#212129] text-[18px] leading-8 mb-6">
                  We are seeking a passionate and enthusiastic Power Apps
                  Developer (Fresher) to join our growing tech team.
                </p>

                <h3 className="text-[20px] font-semibold text-green-600 mb-1">
                  Key Responsibilities
                </h3>
                <div className="w-[100px] h-[2px] bg-green-600 mb-4" />

                <ul className="list-disc ml-6 space-y-2 text-[#212129] text-[18px] leading-7">
                  <li>Develop and customize canvas and model-driven Power Apps.</li>
                  <li>Build automated workflows using Power Automate.</li>
                  <li>Integrate Power Apps with SharePoint, SQL Server, Dataverse.</li>
                  <li>Collaborate with cross-functional teams.</li>
                  <li>Troubleshoot and debug application issues.</li>
                </ul>
              </div>
            </div>

            <div className="bg-white p-6 rounded-2xl shadow-sm max-w-sm w-full">
              <h2 className="text-[32px] font-semibold text-[#212129] mb-6">
                Job Information
              </h2>

              <div className="space-y-4">

                <div className="flex items-center bg-[#F9FAFB] p-4 rounded-xl">
                  <img src={locationIcon} alt="Location" className="w-12 h-12 mr-4" />
                  <div>
                    <p className="text-[#9CA3AF] text-sm font-medium">Location</p>
                    <p className="text-[#111827] text-base">Chennai</p>
                  </div>
                </div>

                <div className="flex items-center bg-[#F9FAFB] p-4 rounded-xl">
                  <img src={fulltimeIcon} alt="Job Type" className="w-12 h-12 mr-4" />
                  <div>
                    <p className="text-[#9CA3AF] text-sm font-medium">Job type</p>
                    <p className="text-[#111827] text-base">Full time</p>
                  </div>
                </div>

                <div className="flex items-center bg-[#F9FAFB] p-4 rounded-xl">
                  <img src={experienceIcon} alt="Experience" className="w-12 h-12 mr-4" />
                  <div>
                    <p className="text-[#9CA3AF] text-sm font-medium">Experience</p>
                    <p className="text-[#111827] text-base">Fresher</p>
                  </div>
                </div>

              </div>
            </div>
          </div>
        </div>
      </div>

      <div ref={applyFormRef} className="bg-[#F6F9FC] px-4 md:px-16 py-12">
        <div className="max-w-3xl mx-auto">
          <h2 className="text-3xl sm:text-4xl font-semibold text-gray-900 mb-4">
            Apply for this role
          </h2>

          <form
            onSubmit={handleSubmit}
            className="space-y-6 bg-white p-6 rounded-xl shadow-md"
          >

            <div>
              <label className="block text-[17px] font-medium mb-2">
                Upload your resume/cv
              </label>

              <div className="border border-dashed border-gray-300 rounded-md p-6 text-center bg-[#FCFCFC]">
                <label
                  htmlFor="resume"
                  className="inline-flex items-center gap-2 px-6 py-2 bg-blue-600 hover:bg-blue-700 text-white font-medium rounded-full cursor-pointer"
                >
                  <img src={uploadIcon} alt="Upload" className="w-5 h-5" />
                  Upload
                </label>

                <input
                  id="resume"
                  name="resume"
                  type="file"
                  accept=".doc,.docx,.pdf,.odt,.rtf"
                  className="hidden"
                  onChange={handleChange}
                  required
                />

                {formData.resume && (
                  <p className="text-sm text-green-600 mt-2">
                    {formData.resume.name}
                  </p>
                )}
              </div>
            </div>

            {["name", "mobile_number", "email"].map((field) => (
              <input
                key={field}
                type={field === "email" ? "email" : "text"}
                name={field}
                placeholder={field.replace("_", " ")}
                value={formData[field]}
                onChange={handleChange}
                required
                className="w-full border border-gray-300 rounded-md p-3 focus:border-green-600 focus:outline-none transition"
              />
            ))}

            <textarea
              name="cover_letter"
              rows="4"
              placeholder="Write your message here..."
              value={formData.cover_letter}
              onChange={handleChange}
              required
              className="w-full border border-gray-300 rounded-md p-3 focus:border-green-600 focus:outline-none transition"
            />

            <button
              type="submit"
              disabled={loading}
              className="w-full bg-green-600 hover:bg-green-700 text-white font-semibold py-3 rounded-md transition"
            >
              {loading ? "Submitting..." : "SUBMIT"}
            </button>

            {message && (
              <p className="text-center text-sm mt-4 text-gray-700">
                {message}
              </p>
            )}
          </form>
        </div>
      </div>
    </>
  );
};

export default JobDetails;
